import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Afterpay from 'components/Afterpay';
import { SECONDARY_STYLES, TERTIARY_STYLES } from 'components/Headings/styles';
import PdpFreeShippingIndicator from 'components/PdpFreeShippingIndicator';
import useShopRunnerWatcher from 'hooks/useShopRunnerWatcher';
import Product from 'models/Product';
import Variant from 'models/Variant';

const ShoprunnerBadge = () => (
  <div className="flex items-center pl-2 pr-2">
    <sr-eligible></sr-eligible>
  </div>
);

const PdpMasterProductDetails = ({
  product,
  currentVariant,
  features,
  pdpStorytellingEnabled,
  descriptionSingleLine,
}) => {
  const priceSource = currentVariant || product;
  const { isLoggedIn } = useShopRunnerWatcher();
  return (
    <div
      className={classNames('PdpMasterProductDetails', {
        'PdpMasterProductDetails--red-sale-price':
          features.enableDiscountPriceColor && priceSource.compareAtPrice,
      })}
    >
      <div className="PdpMasterProductDetails__heading-paragraph-container">
        <div className="grid grid-cols-[1fr,auto] items-baseline gap-x-4 gap-y-2 lg:grid-cols-1">
          <h1 className="text-2xl font-bold lg:text-3.3xl">{product.masterName}</h1>

          {!product.isGiftCard && (
            <div className="flex items-center gap-2 lg:order-last">
              <p
                className={classNames('leading-none', {
                  'text-discount-red':
                    features.enableDiscountPriceColor && priceSource.compareAtPrice,
                })}
              >
                {priceSource.formattedPrice}
              </p>
              {priceSource.compareAtPrice && (
                <p className="text-discount-grey line-through">
                  {priceSource.formattedCompareAtPrice}
                </p>
              )}
              <div className="max-lg:hidden">
                {features.showFreeShippingMessage && (
                  <PdpFreeShippingIndicator itemPrice={product.price} />
                )}
              </div>
              {features.showShoprunner && isLoggedIn && <ShoprunnerBadge />}
            </div>
          )}

          {pdpStorytellingEnabled && descriptionSingleLine?.text && (
            <p className="col-span-full flex-1 overflow-hidden text-base lg:order-2">
              <span className="inline-block">{descriptionSingleLine.text}</span>
            </p>
          )}
        </div>
      </div>

      {features.showAfterpayAboveReviewsStars && (
        <div className="PdpMasterProductDetails__afterpay">
          <Afterpay price={priceSource.price} masterId={product.masterId} />
        </div>
      )}

      <style jsx>{SECONDARY_STYLES}</style>
      <style jsx>{TERTIARY_STYLES}</style>
    </div>
  );
};

PdpMasterProductDetails.propTypes = {
  product: PropTypes.instanceOf(Product).isRequired,
  currentVariant: PropTypes.instanceOf(Variant),
  features: PropTypes.shape({
    showAfterpayAboveReviewsStars: PropTypes.bool,
    showFreeShippingMessage: PropTypes.bool,
    enableDiscountPriceColor: PropTypes.bool,
    showShoprunner: PropTypes.bool,
  }),
  pdpStorytellingEnabled: PropTypes.bool,
  descriptionSingleLine: PropTypes.shape({
    text: PropTypes.string,
  }),
  pdpStorytellingEnabled: PropTypes.bool,
  descriptionSingleLine: PropTypes.shape({
    text: PropTypes.string,
  }),
};

PdpMasterProductDetails.defaultProps = {
  currentVariant: null,
  features: {
    showAfterpayAboveReviewsStars: false,
    showFreeShippingMessage: false,
    enableDiscountPriceColor: false,
    showShoprunner: false,
  },
};

export default PdpMasterProductDetails;
